import { defineCoach } from '../../types';

/** C07: observes the person’s real workflow; navigation is read-only and mutations belong to the page. Arabic copy is DRAFT. */
export const C07 = defineCoach({
  id: 'C07',
  version: 1,
  portal: 'vendor',
  titleKey: 'guidance.coaches.C07.title',
  summaryKey: 'guidance.coaches.C07.summary',
  eligible: (ctx) => ctx.portal === 'vendor',
  steps: [
    {
      id: 'c07-welcome',
      kind: 'explain',
      page: 'vendor.rfqs',
      anchor: null,
      titleKey: 'guidance.coaches.C07.welcome.title',
      bodyKey: 'guidance.coaches.C07.welcome.body',
      route: 'vendor.rfqs',
    },
    {
      id: 'c07-open',
      kind: 'await',
      page: 'vendor.rfqs',
      anchor: 'vendor.rfqs.list',
      titleKey: 'guidance.coaches.C07.open.title',
      bodyKey: 'guidance.coaches.C07.open.body',
      until: {
        route: 'vendor.rfq',
      },
    },
    {
      id: 'c07-requirement',
      kind: 'explain',
      page: 'vendor.rfq',
      anchor: 'vendor.rfq.requirement',
      titleKey: 'guidance.coaches.C07.requirement.title',
      bodyKey: 'guidance.coaches.C07.requirement.body',
    },
    {
      id: 'c07-offer',
      kind: 'explain',
      page: 'vendor.rfq',
      anchor: 'vendor.rfq.offer',
      titleKey: 'guidance.coaches.C07.offer.title',
      bodyKey: 'guidance.coaches.C07.offer.body',
    },
    {
      id: 'c07-documents',
      kind: 'explain',
      page: 'vendor.rfq',
      anchor: 'vendor.rfq.attachments',
      titleKey: 'guidance.coaches.C07.documents.title',
      bodyKey: 'guidance.coaches.C07.documents.body',
    },
    {
      id: 'c07-send-handoff',
      kind: 'handoff',
      page: 'vendor.rfq',
      anchor: ['vendor.rfq.send-card', 'vendor.rfq.send-bar'],
      titleKey: 'guidance.coaches.C07.send-handoff.title',
      bodyKey: 'guidance.coaches.C07.send-handoff.body',
      consequenceKey: 'guidance.coaches.C07.send-handoff.consequence',
    },
    {
      id: 'c07-send',
      kind: 'await',
      page: 'vendor.rfq',
      anchor: ['vendor.rfq.send-card', 'vendor.rfq.send-bar'],
      titleKey: 'guidance.coaches.C07.send.title',
      bodyKey: 'guidance.coaches.C07.send.body',
      until: {
        outcome: 'vendor.quote.submitted',
        route: 'vendor.rfq',
        probe: {
          anchor: 'vendor.rfq.offer',
          in: ['responded', 'incomplete', 'late'],
        },
      },
    },
    {
      id: 'c07-result',
      kind: 'explain',
      page: 'vendor.rfq',
      anchor: 'vendor.rfq.current-offer',
      titleKey: 'guidance.coaches.C07.result.title',
      bodyKey: 'guidance.coaches.C07.result.body',
    },
    {
      id: 'c07-finish',
      kind: 'finish',
      page: 'vendor.rfq',
      anchor: null,
      titleKey: 'guidance.coaches.C07.finish.title',
      bodyKey: 'guidance.coaches.C07.finish.body',
    },
  ],
});
